import styled from '@emotion/styled';
import { Ripple } from '../../atoms/ripple/ripple';
import { Spacing } from '../../atoms/spacing/spacing';
import { css } from '@emotion/react';
import { CardContainer } from '../card/card-container';
import { BreakpointSizes, mq } from '@taleemabad/dsm/themes';
import { TrainingCourseProgressInfo } from '@taleemabad/db';
import bannerImage from '../../../../static/completion-banner.jpg';
import { Typography, IconText } from '@taleemabad/dsm/components';

const StyledProgressContainer = styled.div`
  display: flex;
  padding: var(--rk-spacing-lg);
  width: 100%;
  ${mq(BreakpointSizes.desktop)} {
    padding: var(--rk-spacing-lg);
  }
`;

const StyledContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
`;

export interface CourseProgressBannerProps {
  trainingCourseProgressInfo: TrainingCourseProgressInfo;
  onTrainingCourseProgressBannerClick: (
    course: TrainingCourseProgressInfo,
  ) => void;
}

export const CourseProgressBanner = ({
  trainingCourseProgressInfo,
  onTrainingCourseProgressBannerClick,
}: CourseProgressBannerProps) => {
  const cardContainerStyles = trainingCourseProgressInfo?.allTrainingsCompleted
    ? css`
        // styles for when all trainings are completed
        display: flex;
        min-height: 116px;
        background-image: url(${bannerImage});
        background-size: cover;
        background-position: center;
      `
    : css`
        display: flex;
      `;
  const getCourseCategory = (category: string) => {
    switch (category) {
      case 'GENERAL':
        return 'General';
      case 'SUBJECT':
        return 'Subject';
      case 'FLN':
        return 'Foundational Literacy & Numeracy Courses';
      case 'CHARACTER_EDUCATION':
        return 'Character Education';
      case 'EARLY_YEARS':
        return 'Early Years';
      default:
        return 'General';
    }
  };
  return (
    <CardContainer
      onClick={() =>
        trainingCourseProgressInfo &&
        onTrainingCourseProgressBannerClick(trainingCourseProgressInfo)
      }
      variant="filled"
      minHeight="96px"
      emotionCss={cardContainerStyles}
      data-cy="teacher-training-progress-card-container"
    >
      {trainingCourseProgressInfo.allTrainingsCompleted ? (
        <StyledContent>
          <Spacing marginBottom="md">
            <Typography variant="textHeadlineLargePrimary">
              Congratulations!
            </Typography>
          </Spacing>
          <Typography variant="textLabelLargePrimary">
            You have Completed all Courses
          </Typography>
        </StyledContent>
      ) : (
        <>
          <Ripple />
          <StyledProgressContainer>
            <StyledContent>
              <Typography
                variant="textBodySmallNeutral40"
                data-cy="teacher-training-progress-card-taining-level-and-course"
              >
                Level {trainingCourseProgressInfo?.course?.level?.value} |
                Course {trainingCourseProgressInfo?.course?.index}
              </Typography>
              <Spacing marginTop="md">
                <Typography
                  variant="textTitleSmallOnSurfaceVariant"
                  data-cy="teacher-training-progress-card-taining-title"
                >
                  {trainingCourseProgressInfo?.training?.title}
                </Typography>
              </Spacing>

              <IconText
                icon="east"
                text="Continue"
                textVariant="textLabelMedium"
                size="tiny"
                iconPosition="right"
                iconColor="--md-ref-secondary-40"
              />
            </StyledContent>
          </StyledProgressContainer>
        </>
      )}
    </CardContainer>
  );
};
